import React, { useState } from 'react'
import ContactItem from '../Components/ContactItem';
import phone from '../img/phone.svg';
import email from '../img/emailme.svg';
import location from '../img/location.svg';
import Tittle from '../Components/Tittle';
import emailjs from 'emailjs-com';


function ContactPage() {
    
    const [message, setMessage] = useState(false);

    function sendEmail(e) {
        e.preventDefault();
    
        emailjs.sendForm('service_wgaick7', 'template_9bgdlog', e.target, 'user_kg28qA2nXY0Sh7V1b6mXo')
          .then((result) => {
              console.log(result.text);
              setMessage(true);
          }, (error) => {
              console.log(error.text);
          });
      }
    return (
        <div>
            <div className="title">
                <Tittle title={'Contact'} span={'Contact'} />
            </div>
            <div className="ContactPage">
                <form className="contact-form" onSubmit={sendEmail}>
                    <input type="hidden" name="contact_number" required />
                    <br/>
                    <label>Name</label>
                    <br/>
                    <input type="text" name="user_name" required/>
                    <br/>
                    <label>Email</label>
                    <br/>
                    <input type="email" name="user_email" required/>
                    <br/>
                    <label>Message</label>
                    <br/>
                    <textarea name="message" />
                    <br/>
                    <input className="btn btn-primary" type="submit" value="Send" />
                    <br/>
                    {message && <span style={{color: 'green',padding: '5px'}}>Thanks, I'll reply ASAP :)</span>}
                </form>
            </div>
        </div>
    )
}

export default ContactPage;
